import { action as apiAction } from 'api/Api'

type Payload = {
  predecessorId: number
  name: string
  statusId: number
  groupId?: number
  position?: number
  template: any
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { name, predecessorId, statusId, groupId, position, template } = payload

  const args: any = {
    cardId: predecessorId,
    addCard: {
      name: name.trim(),
      statusId,
      template,
    },
  }

  if (statusId && getState()['view-board'].cards[predecessorId]?.statusId === statusId) {
    args.addCard.statusPosition = { below: predecessorId }
  }

  if (groupId) {
    args.groupTarget = {
      groupId,
      position,
    }
  }

  await apiAction('AddNewNextCard', args)
}
